export const filterArrayBySubString = <T>(array: T[], subStr: string, field: string): T[] => {
  if (!array[0][field as keyof T]) return []
  return array.filter((el) => `${el[field as keyof T]}`.toLowerCase().indexOf(subStr.toLowerCase()) !== -1)
}
